import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/fd/cost-center",
        component: List,
        name: "fd.cost-center.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/cost-center/create",
        component: Create,
        name: "fd.cost-center.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/fd/cost-center/reg-cutting-create",
        component: () => import("../Components/RegCutting.vue"),
        name: "fd-cost-center-reg-cutting-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/fd/cost-center/:id/edit",
        component: Edit,
        name: "fd.cost-center.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
